import { initRuntimeReporter } from "@plerity/runtime-reporter";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// RUM error reporting — was the only React SPA dashboard missing this wiring
// (found in the 2026-07-15 web-app observability audit). Posts to
// /api/observability/errors on chat.animasmarketing.com → chat-api.
initRuntimeReporter({
  app: "chat-admin",
  disabled: import.meta.env.MODE !== "production",
  buildSha: import.meta.env.VITE_BUILD_SHA ?? "dev",
});

const rootEl = document.getElementById("root");
if (rootEl)
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
